// Add the name of a query on this hire page that can be affected by mutations to this array.
// Also add this array to the refetchQueries option in your mutations to update the page after-wards.
export default [
  'HireClassification',
  'GetHireForHeader',
  'GetHireForContractSummary',
  'HireStatusWorkflow',
  'HireGateQuery',
  'HirePageData',
  'HireMilestonesSoWCompliance',
  'HirePageContractsData',
]
